<template>
  <div class="page-content systems">
    <top-menu :setUser="setUser" :user="user" :key="user ? `top-menu-${user._id}` : 'top-menu'"></top-menu>

    <el-row type="flex" justify="center" class="page-body systems-page" v-if=!loading>

      <el-col :xs="{span: 23}" :sm="{span: 24}" class="content-wrapper systems-row">

        <background></background>

        <el-row type="flex" justify="left">

          <el-col :xs="{span: 24}" :sm="{span: 24}" class="inner-systems-row">

            <el-row v-for="(elements, index) in chunkArray(systems, 6)"
                    v-bind:key="`system-row-6-${index}`"
                    type="flex" justify="center"
                    style="width: 100%; margin-top: 3em;"
                    class="hidden-md-and-down">
              <el-col :xs="{span: 4}" :sm="{span: 4}"
                      v-for="(system, innerIndex) in elements"
                      v-bind:key="`system-row-6-${index}-${innerIndex}`"
                      :class="system.slug ? 'system selectable-system' : 'system non-selectable-system'">
                <system-tile :system="system" :handler="openSystemDetails"></system-tile>
              </el-col>
            </el-row>

            <el-row v-for="(elements, index) in chunkArray(systems, 4)"
                    v-bind:key="`system-row-4-${index}`"
                    type="flex" justify="center"
                    style="width: 100%; margin-top: 3em;"
                    class="hidden-sm-and-down hidden-lg-and-up">
              <el-col :xs="{span: 6}" :sm="{span: 4}"
                      v-for="(system, innerIndex) in elements"
                      v-bind:key="`system-row-4-${index}-${innerIndex}`"
                      :class="system.slug ? 'system selectable-system' : 'system non-selectable-system'">
                <system-tile :system="system" :handler="openSystemDetails"></system-tile>
              </el-col>
            </el-row>

            <el-row v-for="(elements, index) in chunkArray(systems, 3)"
                    v-bind:key="`system-row-3-${index}`"
                    type="flex" justify="center"
                    style="width: 100%; margin-top: 3em;"
                    class="hidden-xs-only hidden-md-and-up">
              <el-col :xs="{span: 8}" :sm="{span: 4}"
                      v-for="(system, innerIndex) in elements"
                      v-bind:key="`system-row-3-${index}-${innerIndex}`"
                      :class="system.slug ? 'system selectable-system' : 'system non-selectable-system'">
                <system-tile :system="system" :handler="openSystemDetails"></system-tile>
              </el-col>
            </el-row>

            <el-row v-for="(elements, index) in chunkArray(systems, 1)"
                    v-bind:key="`system-row-1-${index}`"
                    type="flex" justify="center"
                    style="width: 100%; margin-top: 3em;"
                    class="hidden-sm-and-up">
              <el-col :xs="{span: 22}" :sm="{span: 6}"
                      v-for="(system, innerIndex) in elements"
                      v-bind:key="`system-row-1-${index}-${innerIndex}`"
                      :class="system.slug ? 'system selectable-system' : 'system non-selectable-system'">
                <system-tile :system="system" :handler="openSystemDetails"></system-tile>
              </el-col>
            </el-row>

          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <system-dialog v-if="showSystemDetails" :system="showDetailsOfSystem" :onClose="closeSystemDetails"></system-dialog>

    <page-footer :key="'footer'"></page-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import TopMenu from '@/components/top-menu.vue'
import SystemTile from '@/components/system-tile.vue'
import SystemDialog from '@/components/system-dialog.vue'
import Background from '@/components/background.vue'
import PageFooter from '@/components/page-footer.vue'

import chunkArray from '@/utils/chunk-array.js'
import ErrorHandling from '@/utils/error-handling.js'

export default {
  name: 'Systems',
  components: {
    TopMenu,
    Background,
    SystemTile,
    SystemDialog,
    PageFooter
  },
  data () {
    return {
      user: this.$store.state.user,
      loading: false,

      showSystemDetails: false,
      showDetailsOfSystem: {},

      systems: []
    }
  },
  mounted () {
    this.getSystems()
  },
  methods: {
    isEven (value) {
      return value % 2 === 0
    },
    to (name) {
      this.$router.push({ name: name })
    },
    chunkArray,

    setUser (user) {
      if (user) {
        this.$store.commit('user', user)
        this.user = user
      } else {
        this.$store.commit('user', false)
        this.user = false
        this.$router.push({ name: 'home', query: { mode: 'login' } })
      }
    },
    async getSystems () {
      if (this.loading) {
        this.$message.error('Already loading, please wait!')
        return
      }

      this.loading = true

      const res = await this.$http.get('systems')

      if (res.errors && res.errors.length) {
        ErrorHandling(res.errors, 'systems', { handleMessage: this.$message.error })
        this.loading = false
      }

      else {
        for (let system of res.list) {
          system.img = require(`@/assets/${system.avatar}.png`)
          system.imgDetails = require(`@/assets/${system.avatar}-details.png`)
          system.imgHover = system.img
          system.imgDisabled = system.img
        }

        this.systems = this.orderSystems(res.list)
        this.loading = false
      }
    },

    orderSystems (systems) {
      return systems.sort(function (a, b) {
        let nameA = a.name.toUpperCase() // ignore upper and lowercase
        let nameB = b.name.toUpperCase() // ignore upper and lowercase

        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
    },

    openSystemDetails (system) {
      this.showDetailsOfSystem = system
      this.showSystemDetails = true
    },

    closeSystemDetails () {
      this.showDetailsOfSystem = {}
      this.showSystemDetails = false
    }
  }
}
</script>
<style lang="scss">
  @import '../styles/variables.scss';
  .systems {
    .selectable-system {
      border-width: 2px;
      border-style: solid;
      border-color: rgba(255, 255, 255, 0.10);
      border-radius: 25px;
      margin: 3px;
      max-width: 200px;
    }

    .systems-row {
      margin-top: 2em;
    }

    .selectable-system:hover {
      transform: scale(1.02);
      transition-duration: 0.2s;
      cursor: pointer;
      text-shadow: 2px 2px 4px #4e4e4e;
    }

    .non-selectable-system:hover {
      cursor: not-allowed;
    }
  }
</style>
